import { render, staticRenderFns } from "./ship-address.vue?vue&type=template&id=2f3b2ede&scoped=true&"
import script from "./ship-address.vue?vue&type=script&lang=ts&"
export * from "./ship-address.vue?vue&type=script&lang=ts&"
import style0 from "./ship-address.vue?vue&type=style&index=0&id=2f3b2ede&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b2ede",
  null
  
)

export default component.exports